export interface ApiErrorBody {
  error: string;
  message?: string;
}

export async function apiJson<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(path, {
    ...init,
    headers: {
      'content-type': 'application/json',
      ...init?.headers
    }
  });

  if (!response.ok) {
    const body = (await response.json().catch(() => ({ error: 'REQUEST_FAILED' }))) as ApiErrorBody;
    throw new Error(body.message ?? body.error);
  }

  return response.json() as Promise<T>;
}
